export default function InputBase(theme) {
	return {
		MuiInputBase: {
			styleOverrides: {
				sizeSmall: {}
			}
		}
	};
}
